<script setup lang="ts">
import { onMounted, onUnmounted, ref } from 'vue';

const threshold = 300;
const pulsingCircleRef = ref<any | null>(null);

const handleScroll = () => {
  const scrollY = window.scrollY;
  const circleEl = pulsingCircleRef.value?.$el;

  if (circleEl) {
    if (scrollY >= threshold) {
      circleEl.classList.add('stickyCorner');
    } else {
      circleEl.classList.remove('stickyCorner');
    }
  }
};

onMounted(() => {
  window.addEventListener('scroll', handleScroll);
});

onUnmounted(() => {
    window.removeEventListener('scroll', handleScroll);
});
</script>

<template>
  <div class="z-20">
    <router-link
      ref="pulsingCircleRef"
      to="/bli-kund"
      class="pulsing-circle bg-dark-blue w-[12.5rem] h-[12.5rem] 3xl:w-[17.5rem] 3xl:h-[17.5rem] flex items-center justify-center"
      :class="{ 'pulse-border': !static }"
      style="border-radius: 100%"
    >
      <div class="absolute translate-y-[-2.5rem] 3xl:translate-y-[-3.5rem]">
        <svgo-bankid class="w-60 3xl:w-90"></svgo-bankid>
      </div>
      <p class="text-[2rem] 3xl:text-[2.75rem] font-semibold leading-10 text-center text-cyan translate-y-[2.6rem]">Bli kund <br> idag</p>
    </router-link>
  </div>
</template>

<style scoped>
@keyframes pulse-border {
  0% {
    box-shadow: 0 0 10px 5px rgb(255, 255, 255);
  }
  70% {
    box-shadow: 0 0 50px 20px rgba(255, 255, 255);
  }
  100% {
    box-shadow: 0 0 10px 5px rgba(255, 255, 255);
  }
}

.pulse-border {
  position: relative;
  z-index: 1;
}

.pulse-border::before {
  content: '';
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 3px solid #0A1E3F;
  border-radius: 50%;
  animation: pulse-border 4s infinite;
}

.pulsing-circle {
  position: fixed;
  transform-origin: center;
  transition: all 0.5s ease-out;

  @media (max-width: 480px) {
    transform: scale(0.5) !important;
    right: -2rem !important;
    top: calc(100vh - 6rem - 140px) !important;

    /* Safari-specific styles */
    @supports (-webkit-touch-callout: none) {
      top: calc(100vh - 10rem - 140px) !important;
    }
  }

  @media (max-width: 1024px) {
    transform: scale(0.5);
    top: calc(100vh - 6rem - 140px);
    right: -2rem;
  }

  @media (min-width: 1200px) {
    top: 10rem;
    right: 5rem;
  }
}

.pulsing-circle.stickyCorner {
  top: calc(100vh - 6rem - 140px);
  right: -2rem;
  transform: scale(0.5);
}
</style>
